import { Component } from "@opten/compiler/metadata/component";
import { EvaluationComponent } from "./gameEvaluation";
@Component({ className: "js-game-move" })
export class GameInputComponent {
	constructor(private element: HTMLElement) {
		this.element.addEventListener("click", (event) => this.move(event));
	}

	private move(event: Event): void {
		const button = event.target as HTMLElement;
		if (button.tagName !== "BUTTON") {
			return;
		}

		const parent = button.parentElement;
		if (parent) {
			const buttons = parent.querySelectorAll(
				"button"
			) as NodeListOf<HTMLElement>;
			buttons.forEach((btn) => {
				btn.classList.remove("active");
			});
			button.classList.add("active");

			if (button.classList.contains("js-game-last")) {
				var evaluation = new EvaluationComponent(this.element);
				this.element.click();
			}
		}
	}
}
